import { createContext, useCallback, useContext, useMemo } from 'react';

import { findUrl } from './router';

const ApiContext = createContext();

export const ApiContextProvider = ({ authenticationIds, children, routes }) => {
  const getUrl = useCallback(
    ({ apiSettings, type }) =>
      findUrl({ apiSettings, ids: authenticationIds, routes, type }),
    [authenticationIds, routes],
  );

  const value = useMemo(
    () => ({
      authenticationIds,
      getUrl,
    }),
    [authenticationIds, getUrl],
  );

  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
};

export const useApi = () => useContext(ApiContext);
